import { Box, Card, CardMedia, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import domesticPackage from '../data/domesticPackage.json';

const DomesticPackage = () => {
    console.log("entered international package")
    const navigate = useNavigate();
    return (
        <Box p={4}>
            <Typography variant="h4" fontWeight="bold" mb={5}>Trending Domestic Destinations</Typography>
            <Grid container spacing={8}>
                {domesticPackage.map(dest => (
                    <Grid item xs={12} sm={6} md={4} key={dest.id}>
                        <Card sx={{ position: 'relative', overflow: 'visible', boxShadow: 3, cursor: 'pointer' }}
                            onClick={() => navigate(`/domestictrips/${dest.name}`)}>
                            {/* Image */}
                            <Box
                                sx={{
                                    overflow: 'hidden',
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    border: "1px solid black",
                                    '& img': {
                                        transition: 'transform 0.5s ease',
                                    },
                                    '&:hover img': {
                                        transform: 'scale(1.08)',
                                    },
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    sx={{
                                        height: 200, // Set your desired fixed height here
                                        width: 300,
                                        objectFit: 'cover', // or "contain" if you want full image visible with possible empty space
                                    }}
                                    image={dest.featuredImage}
                                    alt={dest.name}
                                />
                            </Box>

                            {/* Overlapping White Box */}
                            <Paper
                                elevation={3}
                                sx={{
                                    position: 'absolute',
                                    bottom: -20,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '75%',
                                    backgroundColor: '#fff',
                                    borderRadius: 5,
                                    p: 1,
                                    textAlign: 'center',
                                    zIndex: 1,
                                    color: "black",
                                    fontWeight: "bold",
                                    
                                }}
                            >
                                <Typography variant="body2">{dest.destinationslug}</Typography>
                            </Paper>
                        </Card>

                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DomesticPackage;
